import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';
import { MultipleChoiceSpoergsmaal } from '../../models/MultipleChoiceSpoergsmaal';
import SvarmulighedComponent from './SvarmulighedComponent';
import { AddContentButton } from '../../uiComponents/input/Buttons';

export interface MultipleChoiceSpoergsmaalComponentProps {
    multipleChoiceSpoergsmaal: MultipleChoiceSpoergsmaal;
    index: number;
    delopgaveIndex: number;
    removeSpoergsmaal: (key: any, delopgaveIndex: number) => void;
    onSpoergsmaalChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;
    addSvarmulighed: (delopgaveIndex: number, spoergsmaalIndex: number) => void;
    onSvarmulighedChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    removeSvarmulighed: (index: number, delopgaveIndex: number, spoergsmaalIndex: number) => void;
    errorMessages: ValidationError[];
}

class MultipleChoiceSpoergsmaalComponent extends React.Component<MultipleChoiceSpoergsmaalComponentProps, any> {
    constructor(props: MultipleChoiceSpoergsmaalComponentProps) {
        super(props);
        this.onChange = this.onChange.bind(this);

        this.getSvarmulighed = this.getSvarmulighed.bind(this);
    }

    onChange(field: string, value: string) {
        this.props.onSpoergsmaalChanged(field, value, this.props.index, this.props.delopgaveIndex);
    }

    getSvarmulighed() {
        if (this.props.multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder !== undefined && this.props.multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder.length > 0) {
            return this.props.multipleChoiceSpoergsmaal.multipleChoiceSvarmuligheder.map((svm, i) =>
                (
                    <SvarmulighedComponent
                        multipleChoiceSvarmulighed={svm}
                        key={i}
                        index={i}
                        delopgaveIndex={this.props.delopgaveIndex}
                        multipleChoiceSpoergsmaalIndex={this.props.index}
                        onSvarmulighedChanged={this.props.onSvarmulighedChanged}
                        errorMessages={this.props.errorMessages}
                        removeSvarmulighed={this.props.removeSvarmulighed}
                    />
                ));
        }

        return [];
    }

    getSvarmuligButton() {
        return (
            <Row>
                <Col md={4}>
                    <AddContentButton text={'Tilføj svarmulighed'} buttonOnClick={() => this.props.addSvarmulighed(this.props.delopgaveIndex, this.props.index)} />
                </Col>
            </Row>
        );
    }

    render() {
        var afsnitErrors = getValidationErrorsForCollection(this.props.errorMessages, 'opgaveafsnit', this.props.index);

        return (
            <div>
                <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.removeSpoergsmaal(this.props.index, this.props.delopgaveIndex)}>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <TextFormGroup
                                errorMessages={afsnitErrors}
                                label='Spørgsmål'
                                name='spoergsmaal'
                                placeholder='Skriv spørgsmål'
                                value={this.props.multipleChoiceSpoergsmaal.spoergsmaal}
                                onChange={this.onChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            {this.getSvarmulighed()}
                            {this.getSvarmuligButton()}
                        </Col>
                    </Row>

                </SectionDynamic>
            </div>
        );
    }
}

export default MultipleChoiceSpoergsmaalComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/MultipleChoiceSpoergsmaalComponent.tsx